<template>
  <div class="flex flex-row items-center gap-2">
    <template v-if="!props.fkSchemaName || !props.fkTableName">
      <div class="text-red-700 text-[0.625rem] h-[1rem]">
        fkSchemaName and fkTableName are required props for FullSelect
        component.
      </div>
    </template>
    <template v-else-if="selectDialogVisible">
      Selecting a value...
      <FormSelectTable
        :table="props.fkTableName"
        :schema="props.fkSchemaName"
        :filter="props.filter"
        v-model:visible="selectDialogVisible"
        @select="
          (val) => {
            value = val[props.valueKey];
          }
        "
      />
    </template>
    <template v-else>
      <PrimeButton
        label="Select"
        icon="pi pi-hashtag"
        @click="selectDialogVisible = true"
      />
    </template>
    <div>
      {{ value }}
    </div>
  </div>

  <!-- <pre>{{ options.data }}</pre> -->
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    inputType?: string;
    error?: string;
    loading?: boolean;
    id?: string;
    fkTableName?: string;
    fkSchemaName?: string;
    options?: any[];
    fetchOptions?: boolean;
    auxInputType?: string;
    editable?: boolean;
    endpoint?: string;
    displayKey?: string;
    searchType?: string;
    valueKey?: string;
    responseKey?: string;
    limit?: number;
    filterEnabled?: boolean;
    filter?: { [key: string]: any };
    tokenData?: { [key: string]: any };
    placeholder?: string;
    defaultExpression?: string;
    dataKey?: string;
    affectFields?: string[];
    showAllOptionInSelect?: boolean;
    required?: boolean;
  }>(),
  {
    disabled: false,
    editable: false,
    dataKey: Math.random().toString().substring(2, 20),
    loading: false,
    fetchOptions: false,
    responseKey: "Results",
    displayKey: "Name",
    valueKey: "Value",
    limit: 40,
    filterEnabled: true,
    tokenData: () => ({}),
    filter: () => ({}),
    affectFields: () => [],
  }
);

const value = defineModel<any>("value");
const dropdownValue = ref<any>();
const form = defineModel<any>("form", {
  default: () => ({}),
});
const actualValue = defineModel<any>("actual");

const selectDialogVisible = ref(false);
</script>

<style scoped></style>
